/**
 * waitingRoomController — P6-13 sala de espera (jugadores, loadout, host Empezar/bots).
 */

import { renderWaitingPlayersHtml } from './waitingRoomTeamView.js';

export { renderWaitingPlayersHtml };

export function isLocalHost(room, clientId) {
  return Boolean(room && clientId && room.hostId === clientId);
}

function setHostControls(els, room, clientId) {
  const host = isLocalHost(room, clientId);
  if (els.fillBtn) els.fillBtn.hidden = !host;
  if (els.startBtn) els.startBtn.hidden = !host;
}

function paintRoom(els, room, clientId) {
  if (els.playersEl) {
    els.playersEl.innerHTML = renderWaitingPlayersHtml(room, {
      localClientId: clientId,
      isHost: isLocalHost(room, clientId)
    });
  }
  if (els.labelEl) {
    const n = room?.players?.length || 0;
    const target = room?.targetSize || '?';
    els.labelEl.textContent =
      `Sala ${room.roomId} · ${n}/${target} · mapa ${room.mapId}`;
  }
  setHostControls(els, room, clientId);
}

/**
 * @param {{
 *   els: object,
 *   client: object,
 *   onOpenLoadout: () => void,
 *   onMatchStart?: (match: object) => void
 * }} opts
 */
export function createWaitingRoomController(opts) {
  const { els, client, onOpenLoadout, onMatchStart } = opts;
  let room = null;

  function showRoom(nextRoom) {
    room = nextRoom;
    paintRoom(els, room, client.getClientId());
  }

  function onState(next) {
    room = next;
    paintRoom(els, room, client.getClientId());
  }

  if (typeof client.onRoomState === 'function') {
    client.onRoomState(onState);
  }

  async function fillBots() {
    if (!room) throw new Error('no_room');
    const target = room.targetSize || 2;
    if (els.statusEl) els.statusEl.textContent = 'Rellenando bots…';
    const next = await client.fillBots(room.roomId, target);
    showRoom(next);
    if (els.statusEl) els.statusEl.textContent = 'Bots añadidos';
    return next;
  }

  async function startMatch() {
    if (!room) throw new Error('no_room');
    if (els.statusEl) els.statusEl.textContent = 'Empezando…';
    const match = await client.startMatch(room.roomId);
    if (els.statusEl) els.statusEl.textContent = 'Partida iniciada';
    if (typeof onMatchStart === 'function') onMatchStart(match);
    return match;
  }

  async function applyTeam(targetClientId, team) {
    if (!room) throw new Error('no_room');
    const me = client.getClientId();
    if (els.statusEl) els.statusEl.textContent = 'Cambiando equipo…';
    const next = me === targetClientId
      ? await client.setTeam(room.roomId, team)
      : await client.assignTeam(room.roomId, targetClientId, team);
    showRoom(next);
    if (els.statusEl) els.statusEl.textContent = 'Equipo actualizado';
    return next;
  }

  if (els.playersEl && typeof els.playersEl.addEventListener === 'function') {
    els.playersEl.addEventListener('click', (ev) => {
      const t = ev?.target;
      const btn = t && typeof t.closest === 'function'
        ? t.closest('[data-set-team]')
        : null;
      if (!btn) return;
      const team = btn.getAttribute('data-set-team');
      const targetId = btn.getAttribute('data-client-id');
      if (!team || !targetId) return;
      applyTeam(targetId, team).catch((err) => {
        if (els.statusEl) els.statusEl.textContent = `Error: ${err.message}`;
      });
    });
  }

  if (els.fillBtn) {
    els.fillBtn.addEventListener('click', () => {
      fillBots().catch((err) => {
        if (els.statusEl) els.statusEl.textContent = `Error: ${err.message}`;
      });
    });
  }
  if (els.startBtn) {
    els.startBtn.addEventListener('click', () => {
      startMatch().catch((err) => {
        if (els.statusEl) els.statusEl.textContent = `Error: ${err.message}`;
      });
    });
  }
  if (els.loadoutBtn) {
    els.loadoutBtn.addEventListener('click', () => {
      if (typeof onOpenLoadout === 'function') onOpenLoadout();
    });
  }

  return {
    showRoom,
    fillBots,
    startMatch,
    applyTeam,
    getRoom: () => room
  };
}

export function bindWaitingRoomFromDocument(doc, opts) {
  const els = {
    playersEl: doc.getElementById('mb-wait-players'),
    labelEl: doc.getElementById('mb-room-ready-label'),
    statusEl: doc.getElementById('mb-status'),
    fillBtn: doc.getElementById('mb-btn-fill-bots'),
    startBtn: doc.getElementById('mb-btn-start-match'),
    loadoutBtn: doc.getElementById('mb-btn-loadout')
  };
  return createWaitingRoomController({ ...opts, els });
}
